import lessIcon from '@/shared/assets/icons/less.svg'
import moreIcon from '@/shared/assets/icons/more.svg'
import { useIsMobile } from '@/shared/utils/useIsMobile/useIsMobile'

type Props = {
  children: React.ReactNode
  type: 'more' | 'less' | 'primary'
  className?: string
  icon?: boolean
}

export const BaseBadge = ({ children, type = 'more', className, icon }: Props) => {
  const isMobile = useIsMobile()
  const baseClasses = `flex gap-1 w-fit items-center rounded-lg py-1 px-[10px] ${isMobile ? 'text-sm' : 'text-base'} whitespace-nowrap`
  const variantClasses = {
    less: 'bg-canceled dark:bg-dark-bg-less text-less-label',
    more: 'bg-light-purple dark:bg-dark-bg-more text-primary',
    primary: 'bg-primary dark:primary-dark text-white',
  }[type]

  const iconClasses = isMobile ? 'w-4 h-4' : 'w-[20px] h-[20px]'
  const iconSrc = type === 'more' ? moreIcon : lessIcon

  return (
    <div className={`${baseClasses} ${variantClasses} ${className || ''}`}>
      {icon && <img src={iconSrc} className={`${iconClasses}`} alt="trend icon" />}
      <span className="font-klein font-medium">{children}</span>
    </div>
  )
}
